module.exports = __webpack_public_path__ + "static/media/target3_1.8959a527.png";